// Yotpo tile fallback v2: handles both preloaded_bottomline (JSON) and
// simple reviews_count/reviews_average attributes.
(function(){
  function paint() {
    var divs = document.querySelectorAll('div.yotpo.bottomLine');
    divs.forEach(function(d){
      // Skip if Yotpo already filled it
      if (d.children.length > 0 && d.innerHTML.replace(/\s/g,'').length > 0) return;
      var total = 0, avg = 0;
      // Try preloaded_bottomline first
      var pb = d.getAttribute('data-yotpo-pb');
      if (pb) {
        try {
          var data = JSON.parse(pb);
          var bl = data.bottomline || {};
          total = parseInt(bl.totalReviews) || 0;
          avg = parseFloat(bl.averageScore) || 0;
        } catch(e) {}
      }
      // Fallback to simple count/avg attrs
      if (total === 0) {
        var ct = d.getAttribute('data-yotpo-count');
        var av = d.getAttribute('data-yotpo-avg');
        if (ct) total = parseInt(ct) || 0;
        if (av) avg = parseFloat(av) || 0;
      }
      if (total === 0) return;
      var avgRounded = Math.round(avg);
      var stars = '';
      for (var i = 1; i <= 5; i++) {
        stars += '<span style="color:' + (i <= avgRounded ? '#000' : '#ccc') + ';font-size:14px;line-height:1;">★</span>';
      }
      d.innerHTML = '<div class="yotpo-tile-fallback" style="display:inline-flex;align-items:center;gap:4px;font-size:13px;color:#000;margin-top:4px;line-height:1;">' + stars + '<span style="margin-left:4px;font-weight:400;">' + total + ' ' + (total === 1 ? 'Review' : 'Reviews') + '</span></div>';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(paint, 1500); });
  } else {
    setTimeout(paint, 1500);
  }
  setTimeout(paint, 4000);
})();
